import { render, staticRenderFns } from "./Foods.vue?vue&type=template&id=e5b5f522&"
import script from "./Foods.vue?vue&type=script&lang=js&"
export * from "./Foods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports